module.exports = __webpack_public_path__ + "static/media/delivery-pickup.7d174206.png";